module.exports = __webpack_public_path__ + "img/108.3bc3c250.jpg";